import { render, staticRenderFns } from "./AdminError.vue?vue&type=template&id=66b29c13"
import script from "./AdminError.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminError.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AdminError.vue?vue&type=style&index=0&id=66b29c13&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports